import { fetchAuthSession } from 'aws-amplify/auth'
import axios from 'axios';
import apiurl from "./apiweb.js"

// Sucursales del emisor: la dirección de la sucursal elegida es la que queda
// impresa en el DTE. La administración (POST/PUT/DELETE) es una segunda etapa;
// por ahora la emisión solo necesita listar las activas.
const ENDPOINT = "sucursales";

const obj = {

    // El rut va sin dígito verificador, igual que RUTEmisor en el DTE.
    getSucursales: async ({ rut, incluirInactivas }) => {
        const token = (await fetchAuthSession()).tokens?.idToken?.toString();
        const params = { rut };
        if (incluirInactivas) params.incluirInactivas = true;

        return axios.get(apiurl + ENDPOINT, {
            headers: {
                'content-type': 'application/json',
                'Authorization': "Bearer " + token,
            },
            params,
            crossdomain: true,
        });
    },
};

export default obj;
